import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from "react-query";

import { storage } from "../../../firebase";
import { fetchPosts, createPost, handleUpdatePost, deletePost } from '../../../hooks/fetchFromFirebase';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DisplayPosts = () => {

  const [selectedPost, setSelectedPost] = useState(null);
  const [newPost, setNewPost] = useState({
    title: "",
    textarea: "",
    image: ""
  });
  // const { data: posts, isLoading, error } = useQuery("dealer posts", fetchPosts);

  const queryClient = useQueryClient();

  const { data: posts, isLoading, error } = useQuery(
    "Dealer posts",
    fetchPosts,
    {
      // Set this to `true` to tell the `useQuery` hook to always
      // fetch fresh data from the server, bypassing the cache.
      staleTime: 0,

      // Use the `queryClient` cache for this query.
      cacheTime: Infinity,
    }
  );

  const handleDelete = async (postId) => {
    const toastSubmission = toast.loading("Παρακαλώ περιμένετε...", { position: toast.POSITION.BOTTOM_RIGHT});
    try {
      // Delete the post and its image from Firestore and Firebase Storage
      await deletePost(postId);

      // Update the toast to indicate success
      toast.update(toastSubmission, { render: "Επιτυχής διαγραφή", type: "success", autoClose: 5000, hideProgressBar: false, isLoading: false, position: toast.POSITION.BOTTOM_RIGHT });

      // Invalidate and refetch the "posts" query to update the UI
      queryClient.invalidateQueries("Dealer posts");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <div>Loading posts...</div>;
  }

  if (error) {
    return <div>Error loading posts: {error.message}</div>;
  }
  
    return (
      <div className='container posts-list equal-heights-container padding-vert-40'>
        <div className="title-container fs-3vw fw-900 blue vertical">
          Προωθητικές Ενέργειες
        </div>

        <div className="content-container border-left-blue padding-left-20">
          <div className="row">
            <div className="col s12">
                <div className="fs-2vw fw-900 blue ta-center">Λίστα προωθητικών ενεργειών</div>
            </div>
          </div>

          <div className="row">
            <div className="col s12">
              <table className="dashboard-form project-list-table">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Τίτλος</th>
                        <th scope="col">Ενέργειες</th>
                    </tr>
                </thead>
                <tbody>
                  {posts.length > 0 ? (
                    posts.map((post, i) => (
                      <tr key={post.id}>
                        <td>{i+1}</td>
                        <td>{post.title}</td>
                        <td>
                          {/* <Link to={`/dashboard/posts/edit/${post.id}`}>
                            <button className="margin-hor-10">Edit</button>
                          </Link> */}
                          <button className="margin-hor-10" onClick={() => handleDelete(post.id)}>Delete</button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td></td>
                      <td>Δεν βρέθηκαν άρθρα</td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
                  
          {posts.length < 3 && (
            <div className="row">
                <div className='col s12 ta-center padding-vert-10'>
                  <Link to={`/dashboard/posts/create`}>
                    <button type="submit">Δημιουργία άρθρου</button>
                  </Link>
                </div>
            </div>
          )}

      </div>
      <ToastContainer autoClose={5000} />
    </div>
    );
  };
  
  export default DisplayPosts;